/* eslint-disable @typescript-eslint/camelcase */
import { call, put, all, takeLatest } from 'redux-saga/effects'
import { fetchCollectorStats } from '../../api/stats'
import { StatsActions, FETCH_COLLECTOR_STATS } from './actions'

export function* loadCollectorStats() {
  try {
    const { data } = yield call(fetchCollectorStats)
    yield put(StatsActions.fetchCollectorStatsSuccess(data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* rootSaga() {
  yield all([takeLatest(FETCH_COLLECTOR_STATS, loadCollectorStats)])
}
